import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RachatAmountFormComponent } from './rachat-amount-form.component';

@UntilDestroy()
@Component({
  selector: 'rachat-programmed-amount-form',
  templateUrl: './rachat-amount-form.component.html',
  styleUrls: ['./rachat-amount-form.component.scss'],
  standalone: false,
})
export class RachatProgrammedAmountFormComponent extends RachatAmountFormComponent {
  protected override get formOptions(): any {
    return { programmed: true };
  }
}
